module.exports = __webpack_public_path__ + "static/media/cctv4.0f2bea6f.png";